'use client';

import Image from '@/components/Image';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import Link from 'next/link';

const PolarizedLenses = () => {
  return (
    <>
      <WebOnly>
        <div className="bg-white w-[80%] mx-auto pb-[134px]">
          {/* 顶部横幅 */}
          <Image
            className="w-full"
            width={1200}
            height={500}
            src="/static-page/guide-tips/polarized-lenses/top-banner.png"
            alt=""
          />

          {/* 标题与说明 */}
          <div className="mt-[60px] mb-[60px] text-[36px]">
            Polarisierende Sonnenbrillen: effektiver Schutz vor Blendung
          </div>
          <div className="my-[28px] text-[22px]">
            Die Wirkung der Zeelool Polarisierenden Sonnenbrillengläser in verschiedenen Farben im
            Innen- und Außenbereich
          </div>
          <div className="text-[16px] leading-[24px]">
            Sind Sie sich nicht sicher, welche Farbe die Polarisierende Sonnenbrillengläser von
            Zeelool tatsächlich haben? Dieses Video hilft Ihnen weiter! Tipp: Die Farbe von Gläsern
            wird durch den Aufnahmewinkel und die Intensität des Lichts beeinflusst. Das Video dient
            nur zur Information.
          </div>

          {/* 视频 */}
          <div className="my-[30px] mb-[55px]">
            <video
              className="w-full"
              src="https://common.xmslol.com/video/zeelool-de/polarized-lenses.mp4"
              controls
            />
          </div>

          {/* 特性 */}
          <div className="my-[28px] text-[22px] ">
            Eigenschaften von Polarisierende Sonnenbrillengläser
          </div>
          <div className="text-[16px] leading-[24px]">
            Polarisierende Brillengläser nutzen das Prinzip der Polarisation, um Streulicht effektiv
            zu filtern. Sie verhindern, dass grelles Licht von Wasser, Schnee, Windschutzscheiben,
            Scheinwerfern usw. Ihre Sicht beeinträchtigt, und filtern außerdem schädliche
            UV-Strahlen, so dass das Licht nicht mehr blendet! Bietet ultimativen Schutz für Ihre
            Augen!
          </div>

          <div className="my-[28px] text-[22px] ">
            Anwendungsszenarien für Polarisierende Sonnenbrillen
          </div>
          <div className="text-[16px] leading-[24px]">
            Geeignet für Autofahren, Skifahren, Radfahren, Wassersport und andere
            Outdoor-Aktivitäten, verhindert effektiv grelle Blendung und filtert UV-Strahlen, bietet
            perfekten Schutz für Ihre Augen!
          </div>
          {/* 应用场景：水面 */}
          <div className="flex mt-[50px]">
            <div className="w-1/2 pr-[8%]">
              <div className="my-[28px] text-[22px] ">Auf dem Wasser</div>
              <div className="text-[16px] leading-[24px]">
                Tragen Sie bei sommerlichen Bootsausflügen Polarisierende Sonnenbrillen, um Ihre
                Augen vor störenden Wasserreflexionen und UV-Strahlen zu schützen und Ihre
                Bootsausflüge entspannter und angenehmer zu gestalten.
              </div>
            </div>
            <div className="w-[60%] flex justify-between">
              <div className="flex flex-col items-center justify-center">
                <Image
                  className="block w-full"
                  width={560}
                  height={300}
                  src="/static-page/guide-tips/polarized-lenses/water-without-polarized.png"
                  alt=""
                />
                <span className="mt-[18px] text-[16px]">Ohne Polarisierende Brillengläser</span>
              </div>
              <div className="flex flex-col items-center justify-center">
                <Image
                  className="block w-full"
                  width={560}
                  height={300}
                  src="/static-page/guide-tips/polarized-lenses/water-with-polarized.png"
                  alt=""
                />
                <span className="mt-[18px] text-[16px]">Mit Polarisierende Brillengläser</span>
              </div>
            </div>
          </div>

          {/* 应用场景：雪地 */}
          <div className="flex mt-[50px]">
            <div className="w-1/2 pr-[8%]">
              <div className="my-[28px] text-[22px] ">Auf der Piste</div>
              <div className="text-[16px] leading-[24px]">
                Eine Polarisierende Sonnenbrille ist kein Ersatz für eine Skibrille, aber sie ist
                eine fantastische Idee für alles, was Sie abseits der Piste tun. Polarisierende
                Sonnenbrillengläser schützen Ihre Augen, indem sie die vom Schnee reflektierte
                Blendung reduzieren.
              </div>
            </div>
            <div className="w-[60%] flex justify-between">
              <div className="flex flex-col items-center justify-center">
                <Image
                  className="block w-full"
                  width={560}
                  height={300}
                  src="/static-page/guide-tips/polarized-lenses/snow-without-polarized.png"
                  alt=""
                />
                <span className="mt-[18px] text-[16px]">Ohne Polarisierende Brillengläser</span>
              </div>
              <div className="flex flex-col items-center justify-center">
                <Image
                  className="block w-full"
                  width={560}
                  height={300}
                  src="/static-page/guide-tips/polarized-lenses/snow-with-polarized.png"
                  alt=""
                />
                <span className="mt-[18px] text-[16px]">Mit Polarisierende Brillengläser</span>
              </div>
            </div>
          </div>

          {/* 应用场景：行车 */}
          <div className="flex mt-[50px]">
            <div className="w-1/2 pr-[8%]">
              <div className="my-[28px] text-[22px] ">Im Auto</div>
              <div className="text-[16px] leading-[24px]">
                Mit einer Polarisierenden Sonnenbrille werden Sie beim Autofahren nicht mehr
                geblendet, was Ihnen ein sicheres Fahrgefühl vermittelt.
              </div>
            </div>
            <div className="w-[60%] flex justify-between">
              <div className="flex flex-col items-center justify-center">
                <Image
                  className="block w-full"
                  width={560}
                  height={300}
                  src="/static-page/guide-tips/polarized-lenses/car-without-polarized.png"
                  alt=""
                />
                <span className="mt-[18px] text-[16px]">Ohne Polarisierende Brillengläser</span>
              </div>
              <div className="flex flex-col items-center justify-center">
                <Image
                  className="block w-full"
                  width={560}
                  height={300}
                  src="/static-page/guide-tips/polarized-lenses/car-with-polarized.png"
                  alt=""
                />
                <span className="mt-[18px] text-[16px]">Mit Polarisierende Brillengläser</span>
              </div>
            </div>
          </div>

          {/* 对比说明 */}
          <div className="my-[20px] text-[22px] ">
            Polarisierende Sonnenbrillengläser vs. Selbsttönende Brillengläser vs. Normale
            Sonnenbrillengläser
          </div>
          <div className="text-[16px] leading-[24px]">
            Polarisierende Sonnenbrillengläser: Die Farben des In- und Outdoor-Bereichs sind
            identisch. Es filtert schädliche UV-Strahlen und schützt auch vor Blendung.
          </div>
          <div className="text-[16px] leading-[24px]">
            Selbsttönende Brillengläser: Indoor ist es transparent, Outdoor dunkelt die Farbe nach.
            Filtert schädliche UV-Strahlen heraus.
          </div>
          <div className="text-[16px] leading-[24px]">
            Normale Sonnenbrillengläser: Gleiche Farbe für drinnen und draußen, filtert schädliche
            UV-Strahlen.
          </div>
          <div className="flex justify-between my-[28px] mb-[35px]">
            <div className="w-[28.8%]">
              <Image
                className="block w-full"
                width={283}
                height={184}
                src="/static-page/guide-tips/polarized-lenses/polarized-sunglasses.png"
                alt=""
              />
              <span className="block mt-[20px] text-center">
                Polarisierende Sonnenbrillengläser
              </span>
            </div>
            <div className="w-[28.8%]">
              <Image
                className="block w-full"
                width={283}
                height={184}
                src="/static-page/guide-tips/polarized-lenses/photochromic-lenses.png"
                alt=""
              />
              <span className="block mt-[20px] text-center">Selbsttönende Brillengläser</span>
            </div>
            <div className="w-[28.8%]">
              <Image
                className="block w-full"
                width={283}
                height={184}
                src="/static-page/guide-tips/polarized-lenses/normal-sunglasses.png"
                alt=""
              />
              <span className="block mt-[20px] text-center">Normale Sonnenbrillengläser</span>
            </div>
          </div>

          {/* 链接与购买 */}
          <div className="mb-[75px] text-[16px] ">
            Erfahren Sie hier mehr über Selbsttönende Brillengläser:{' '}
            <Link className="underline" href="/guide-tips/photochromic-lenses">
              Selbsttönende Brillengläser
            </Link>
          </div>
          <div className="my-[28px] text-[22px] ">
            Shop für Zeelool Polarisierende Sonnenbrillen
          </div>
          <div className="text-[16px] leading-[24px]">
            Alle Vollrandbrillen von Zeelool (800+ Designermodelle) können mit Polarisierende
            Sonnenbrillengläsern ausgestattet werden, unabhängig davon, ob Sie Ihre Sehstärke
            anpassen möchten oder nicht. Sie bieten einen hervorragenden Blend- und UV-Schutz für
            Ihre Augen und sorgen für klare Sicht! Damit das Licht nicht blendet!
          </div>
          <Link
            className="flex items-center justify-center w-[220px] h-[50px] mt-[30px] bg-[#463ae8] text-white text-[16px]"
            href="/"
          >
            Jetzt kaufen
          </Link>
        </div>
      </WebOnly>
      <WapOnly>
        <div className="bg-white pt-0 pb-0">
          {/* 顶部大图 */}
          <Image
            className="w-full"
            width={750}
            height={380}
            src="/static-page/guide-tips/polarized-lenses/top-banner.png"
            alt=""
          />

          {/* 标题与说明 */}
          <div className="mt-[24px] mb-[40px] text-[22px]">
            Polarisierende Sonnenbrillen: effektiver Schutz vor Blendung
          </div>
          <div className="my-[29px] text-[18px]">
            Die Wirkung der Zeelool Polarisierenden Sonnenbrillengläser in verschiedenen Farben im
            Innen- und Außenbereich
          </div>
          <div className="text-[14px] leading-[22px] text-[#333333]">
            Sind Sie sich nicht sicher, welche Farbe die Polarisierende Sonnenbrillengläser von
            Zeelool tatsächlich haben? Dieses Video hilft Ihnen weiter!
          </div>
          <div className="text-[14px] leading-[22px] text-[#666666] mt-[10px]">
            Tipp: Die Farbe von Gläsern wird durch den Aufnahmewinkel und die Intensität des Lichts
            beeinflusst. Das Video dient nur zur Information.
          </div>

          {/* 视频 */}
          <div className="mt-[22px] mb-[40px]">
            <video
              className="w-full"
              src="https://common.xmslol.com/video/zeelool-de/polarized-lenses.mp4"
              controls
            />
          </div>

          {/* 特性说明 */}
          <div className="my-[40px] text-[18px] font-bb">
            Eigenschaften von Polarisierende Sonnenbrillengläser
          </div>
          <div className="text-[14px] leading-[22px] text-[#333333]">
            Polarisierende Brillengläser nutzen das Prinzip der Polarisation, um Streulicht effektiv
            zu filtern. Sie verhindern, dass grelles Licht von Wasser, Schnee, Windschutzscheiben,
            Scheinwerfern usw. Ihre Sicht beeinträchtigt, und filtern außerdem schädliche
            UV-Strahlen, so dass das Licht nicht mehr blendet! Bietet ultimativen Schutz für Ihre
            Augen!
          </div>

          {/* 应用场景总述 */}
          <div className="my-[40px] text-[18px] font-bb">
            Anwendungsszenarien für Polarisierende Sonnenbrillen
          </div>
          <div className="text-[14px] leading-[22px] text-[#333333]">
            Geeignet für Autofahren, Skifahren, Radfahren, Wassersport und andere
            Outdoor-Aktivitäten, verhindert effektiv grelle Blendung und filtert UV-Strahlen, bietet
            perfekten Schutz für Ihre Augen!
          </div>

          {/* 场景：水面 */}
          <div className="flex flex-col">
            <div className="w-full p-0">
              <div className="my-[28px] text-[18px] font-bb">Auf dem Wasser</div>
              <div className="text-[14px] leading-[22px] text-[#333333]">
                Tragen Sie bei sommerlichen Bootsausflügen Polarisierende Sonnenbrillen, um Ihre
                Augen vor störenden Wasserreflexionen und UV-Strahlen zu schützen und Ihre
                Bootsausflüge entspannter und angenehmer zu gestalten.
              </div>
            </div>
            <div className="w-full mt-[20px] flex justify-between">
              <div className="w-[48%] flex flex-col items-center">
                <Image
                  className="w-full"
                  width={690}
                  height={394}
                  src="/static-page/guide-tips/polarized-lenses/water-without-polarized.png"
                  alt=""
                />
                <span className="mt-[10px] text-[14px] text-center">
                  Ohne Polarisierende Brillengläser
                </span>
              </div>
              <div className="w-[48%] flex flex-col items-center">
                <Image
                  className="w-full"
                  width={690}
                  height={394}
                  src="/static-page/guide-tips/polarized-lenses/water-with-polarized.png"
                  alt=""
                />
                <span className="mt-[10px] text-[14px] text-center">
                  Mit Polarisierende Brillengläser
                </span>
              </div>
            </div>
          </div>

          {/* 场景：雪地 */}
          <div className="flex flex-col">
            <div className="w-full p-0">
              <div className="my-[28px] text-[18px] font-bb">Auf der Piste</div>
              <div className="text-[14px] leading-[22px] text-[#333333]">
                Eine Polarisierende Sonnenbrille ist kein Ersatz für eine Skibrille, aber sie ist
                eine fantastische Idee für alles, was Sie abseits der Piste tun. Polarisierende
                Sonnenbrillengläser schützen Ihre Augen, indem sie die vom Schnee reflektierte
                Blendung reduzieren.
              </div>
            </div>
            <div className="w-full mt-[20px] flex justify-between">
              <div className="w-[48%] flex flex-col items-center">
                <Image
                  className="w-full"
                  width={690}
                  height={394}
                  src="/static-page/guide-tips/polarized-lenses/snow-without-polarized.png"
                  alt=""
                />
                <span className="mt-[10px] text-[14px] text-center">
                  Ohne Polarisierende Brillengläser
                </span>
              </div>
              <div className="w-[48%] flex flex-col items-center">
                <Image
                  className="w-full"
                  width={690}
                  height={394}
                  src="/static-page/guide-tips/polarized-lenses/snow-with-polarized.png"
                  alt=""
                />
                <span className="mt-[10px] text-[14px] text-center">
                  Mit Polarisierende Brillengläser
                </span>
              </div>
            </div>
          </div>

          {/* 场景：行车 */}
          <div className="flex flex-col">
            <div className="w-full p-0">
              <div className="my-[28px] text-[18px] font-bb">Im Auto</div>
              <div className="text-[14px] leading-[22px] text-[#333333]">
                Mit einer Polarisierenden Sonnenbrille werden Sie beim Autofahren nicht mehr
                geblendet, was Ihnen ein sicheres Fahrgefühl vermittelt.
              </div>
            </div>
            <div className="w-full mt-[20px] flex justify-between">
              <div className="w-[48%] flex flex-col items-center">
                <Image
                  className="w-full"
                  width={690}
                  height={394}
                  src="/static-page/guide-tips/polarized-lenses/car-without-polarized.png"
                  alt=""
                />
                <span className="mt-[10px] text-[14px] text-center">
                  Ohne Polarisierende Brillengläser
                </span>
              </div>
              <div className="w-[48%] flex flex-col items-center">
                <Image
                  className="w-full"
                  width={690}
                  height={394}
                  src="/static-page/guide-tips/polarized-lenses/car-with-polarized.png"
                  alt=""
                />
                <span className="mt-[10px] text-[14px] text-center">
                  Mit Polarisierende Brillengläser
                </span>
              </div>
            </div>
          </div>

          {/* 三段对比（文字 + 图片） */}
          <div className="my-[30px] text-[18px] font-bb">
            Polarisierende Sonnenbrillengläser vs. Selbsttönende Brillengläser vs. Normale
            Sonnenbrillengläser
          </div>
          <div className="flex flex-col mb-0">
            <div className="w-full">
              <div className="text-[14px] leading-[22px] text-[#333333]">
                Polarisierende Sonnenbrillengläser:
                <br />
                Die Farben des In- und Outdoor-Bereichs sind identisch. Es filtert schädliche
                UV-Strahlen und schützt auch vor Blendung.
              </div>
              <Image
                className="w-full my-[16px] mb-[20px]"
                width={690}
                height={388}
                src="/static-page/guide-tips/polarized-lenses/polarized-sunglasses.png"
                alt=""
              />
            </div>
            <div className="w-full">
              <div className="text-[14px] leading-[22px] text-[#333333]">
                Selbsttönende Brillengläser:
                <br />
                Indoor ist es transparent, Outdoor dunkelt die Farbe nach. Filtert schädliche
                UV-Strahlen heraus.
              </div>
              <Image
                className="w-full my-[16px] mb-[20px]"
                width={690}
                height={388}
                src="/static-page/guide-tips/polarized-lenses/photochromic-lenses.png"
                alt=""
              />
            </div>
            <div className="w-full">
              <div className="text-[14px] leading-[22px] text-[#333333]">
                Normale Sonnenbrillengläser:
                <br />
                Gleiche Farbe für drinnen und draußen, filtert schädliche UV-Strahlen.
              </div>
              <Image
                className="w-full my-[16px] mb-[20px]"
                width={690}
                height={388}
                src="/static-page/guide-tips/polarized-lenses/normal-sunglasses.png"
                alt=""
              />
            </div>
          </div>

          {/* 引导链接与购买按钮 */}
          <div className="mb-[40px] text-[16px] font-bb">
            <span className="inline-block">
              Erfahren Sie hier mehr über Selbsttönende Brillengläser:&nbsp;
              <Link className="underline inline-block" href="/guide-tips/photochromic-lenses">
                Selbsttönende Brillengläser
              </Link>
            </span>
          </div>

          <div className="my-[29px] text-[18px] font-bb">
            Shop für Zeelool Polarisierende Sonnenbrillen
          </div>
          <div className="text-[14px] leading-[22px] text-[#333333]">
            Alle Vollrandbrillen von Zeelool (800+ Designermodelle) können mit Polarisierende
            Sonnenbrillengläsern ausgestattet werden, unabhängig davon, ob Sie Ihre Sehstärke
            anpassen möchten oder nicht. Sie bieten einen hervorragenden Blend- und UV-Schutz für
            Ihre Augen und sorgen für klare Sicht! Damit das Licht nicht blendet!
          </div>
          <Link
            className="flex items-center justify-center w-[140px] h-[35px] mt-[30px] bg-[#463ae8] text-white text-[14px] mb-[40px]"
            href="/"
          >
            Jetzt kaufen
          </Link>
        </div>
      </WapOnly>
    </>
  );
};

export default PolarizedLenses;
